import React from 'react';
import { ClipLoader } from 'react-spinners';

const Loader = () => {
  return (
    <div className="fixed inset-0 z-50 bg-gray-800 bg-opacity-50 backdrop-blur-sm flex justify-center items-center">
      <ClipLoader
        color="#1D4ED8"
        size={50}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
};

export default Loader;
